import { FC } from 'react';

export const Download: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 3C12.5523 3 13 3.44772 13 4L13 13.5858L15.2929 11.2929C15.6834 10.9024 16.3166 10.9024 16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929C7.68341 10.9024 8.31658 10.9024 8.7071 11.2929L11 13.5858L11 4C11 3.44772 11.4477 3 12 3ZM4 15C4.55228 15 5 15.4477 5 16V18C5 18.5523 5.44771 19 6 19H18C18.5523 19 19 18.5523 19 18V16C19 15.4477 19.4477 15 20 15C20.5523 15 21 15.4477 21 16V18C21 19.6568 19.6569 21 18 21H6C4.34315 21 3 19.6568 3 18V16C3 15.4477 3.44772 15 4 15Z"
			fill="currentColor"
		/>
	</svg>
);
